//TODO remove this file

export const XS: number = 0;
export const SM: number = 560;
export const MD: number = 768;
export const LG: number = 992;
export const XL: number = 1200;
export const XXL: number = 1500;

export const BREAKPOINT_XS: string = 'xs';
export const BREAKPOINT_SM: string = 'sm';
export const BREAKPOINT_MD: string = 'md';
export const BREAKPOINT_LG: string = 'lg';
export const BREAKPOINT_XL: string = 'xl';
export const BREAKPOINT_XXL: string = 'xxl';

export const BREAKPOINTS: object = {
  [BREAKPOINT_XS]: XS,
  [BREAKPOINT_SM]: SM,
  [BREAKPOINT_MD]: MD,
  [BREAKPOINT_LG]: LG,
  [BREAKPOINT_XL]: XL,
  [BREAKPOINT_XXL]: XXL,
};
